module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoM.a5b0012.woff";